import { useEffect, useState } from "react";
import { Instagram, ArrowUpRight } from "lucide-react";
import { api, resolveImg, INSTAGRAM_DEFAULT } from "../../lib/site";
import { Reveal, Overline } from "./ui";

export default function Gallery({ instagramUrl }) {
  const [items, setItems] = useState([]);
  const [ready, setReady] = useState(false);
  const ig = instagramUrl || INSTAGRAM_DEFAULT;

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => {}).finally(() => setReady(true));
  }, []);

  if (!ready || items.length === 0) return null;

  return (
    <section id="gallery" className="relative bg-ink px-5 py-24 md:px-10 md:py-32" data-testid="gallery-section">
      <div className="mx-auto max-w-[1400px]">
        <Reveal className="mb-12 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <Overline>On the road</Overline>
            <h2 className="mt-4 font-heading text-3xl font-bold uppercase tracking-tight text-white sm:text-4xl md:text-5xl">
              Straight from our Instagram
            </h2>
          </div>
          <a
            href={ig}
            target="_blank"
            rel="noreferrer"
            data-testid="gallery-instagram-cta"
            className="inline-flex w-fit items-center gap-2 border border-white/20 px-5 py-3 text-xs font-bold uppercase tracking-wider text-white transition-colors hover:border-volt hover:text-volt"
          >
            <Instagram size={16} /> Follow @rentabikekohima
          </a>
        </Reveal>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {items.map((it, i) => (
            <Reveal key={it.id} delay={(i % 6) * 0.05}>
              <a
                href={ig}
                target="_blank"
                rel="noreferrer"
                data-testid={`gallery-item-${it.id}`}
                className="group relative block aspect-square overflow-hidden border border-white/10"
              >
                <img src={resolveImg(it.image_url)} alt={it.caption || "Instagram photo"} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-ink/90 via-ink/10 to-transparent p-3 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <Instagram size={16} className="text-volt" />
                  {it.caption && <span className="mt-1 line-clamp-2 text-[11px] font-medium text-white">{it.caption}</span>}
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
